<script>
  import { v4 as uuidv4 } from "uuid";
  import { onMount } from "svelte";
  import { gsap } from "gsap";
  import SectionTitle from "./SectionTitle.svelte";
  import ArrowDown from "./ArrowDown.svelte";
  import Button from "./Button.svelte";

  const lightBackgroundImage = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/background_intro_light.png";
  const darkBackgroundImage = "https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/background_intro_dark.png";

  export let title = "The title";
  export let subtitle = "The subtitle";
  export let pictureUrl = "https://www.ingenilab.com/images/logo-bulb.svg";
  export let dark = false;

  const componentId = "intro__" + uuidv4();

  onMount(() => {
    gsap.from("#" + componentId + " .intro__picture img", {
      opacity: 0,
      rotationX: 33,
      rotationY: 33,
      xPercent: dark ? 10 : -10,
      ease: "power",
      delay: 0.5,
      duration: 0.2,
    });

    gsap.to("#" + componentId, {
      backgroundPosition: dark ? "50% 400px" : "50% -400px",
      ease: "none",
      scrollTrigger: {
        trigger: "#" + componentId,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  function handleClick(event) {
    if (dark) {
      window.open(
        "https://www.decathlon.fr/p/chaussures-de-tennis-homme-ts960-bleues-multi-court/_/R-p-300486?mc=8573383",
        "_blank"
      );
    } else {
      window.open(
        "https://www.decathlon.fr/p/chaussures-de-tennis-homme-ts990-jaunes-multi-court/_/R-p-300116?mc=8573378",
        "_blank"
      );
    }
  }
</script>

<article
  class="intro {$$props.class}"
  style="background-image: url('{dark
    ? darkBackgroundImage
    : lightBackgroundImage}');"
  id={componentId}
>
  <div
    class="intro__section"
    class:intro__section--light={!dark}
    class:intro__section--dark={dark}
  >
    <SectionTitle {title} {subtitle} {dark} />
    <div class="intro__picture">
      <img src={pictureUrl} alt={title} />
    </div>
    <div class="intro__actions">
      <Button label={"Voir le produit"} {dark} on:click={handleClick} />
      <ArrowDown {dark} />
    </div>
  </div>
</article>

<style lang="scss">
  @import "./assets/styles/variables";

  .intro {
    background-position: 50% 0;
    background-repeat: no-repeat;

    &__section {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    &__picture {
      margin: 0 auto;

      img {
        max-width: 100%;
        width: 476px;
      }
    }

    &__actions {
      align-items: center;
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
</style>
